module.exports = __webpack_public_path__ + "6778559dd6e3df54dbe37c24313514c4.woff2";